import { useStateValue } from '../../index'
import { set, setLeadTokenOption, toggle, updateLocation, setPrivacy, setPageBackgroundOption } from '../actions'

const useOptions = () => {
  const [{ options }, dispatch] = useStateValue()

  const setLocation = (payload) => {
    dispatch(updateLocation(payload))
  }

  const setPageBackground = (payload) => {
    dispatch(setPageBackgroundOption(payload))
  }

  const setActivePanels = (payload) => {
    dispatch(set(payload))
  }

  const toggleAllPanels = (payload) => {
    if (!options.isExpanded) {
      const active = []
      for (var i = 0; i <= payload.length; i++) {
        active.push(i)
      }
      dispatch(set(active))
    } else {
      dispatch(set([]))
    }
    dispatch(toggle())
  }

  const setPrivacyStatus = (payload) => {
    dispatch(setPrivacy(payload))
  }

  const setLeadToken = (payload) => {
    dispatch(setLeadTokenOption(payload))
  }

  return { options, setActivePanels, setLeadToken, toggleAllPanels, setLocation, setPrivacyStatus, setPageBackground }
}

export default useOptions